export default __webpack_public_path__ + "static/media/REVISTA.d02889f0.ttf";